import { render, staticRenderFns } from "./DayInactivityIntervalsListTable.vue?vue&type=template&id=e63f2e7c&"
import script from "./DayInactivityIntervalsListTable.vue?vue&type=script&lang=ts&"
export * from "./DayInactivityIntervalsListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports